<template>
  <div>
    <el-table :data="list" style="width: 100%;padding-top: 15px;" stripe class="table-wrap">
      <el-table-column label="小区名称" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.communityName }}
        </template>
      </el-table-column>
      <el-table-column label="今日订单量" width="195" align="center">
        <template slot-scope="scope">
          {{ scope.row.orderNums | toThousandFilter }}
        </template>
      </el-table-column>
      <el-table-column label="总单量" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.totalOrderNums }}
        </template>
      </el-table-column>
    </el-table>
  </div>
   
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        success: 'success',
        pending: 'danger'
      }
      return statusMap[status]
    },
    orderNoFilter(str) {
      return str.substring(0, 30)
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  }
}
</script>
<style lang="scss">
.el-table.table-wrap { 
  color:#E1E6E6;
  tr {
    background: transparent;
  } 
  padding-bottom: 27px;
}
.el-table.table-wrap::before {
  background-color:transparent;
}
.el-table.table-wrap, .el-table__expanded-cell {
  background-color: transparent !important;
}    
.table-wrap th.el-table__cell {
  color:#E1E6E6;
  background: transparent;
} 
.el-table.table-wrap td.el-table__cell, .el-table th.el-table__cell.is-leaf {
  border: none;
}
.el-table__row:hover>td.el-table__cell {
  background-color: transparent !important;;
}  
.el-table__row.el-table__row--striped td.el-table__cell {
  background-color:#4EA4E1FF !important;
}
</style>